import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Modal } from "antd";
import React from "react"
import { AppDispatch } from "../../../../store/app";
import { useDispatch } from "react-redux";
import { editSupportProvider } from "../../../../store/SupportProviderSlice";
import FormSupportProvider from "./FormSupportProvider";

const EditSupportProvider: React.FC<any> = ({
    openEditModal,
    handleEditModal,
    getList,
    editModalData
}) => {
    const dispatch: AppDispatch = useDispatch();
    const [form] = Form.useForm();
    const handleEditSubmit = (data: any) => {
        dispatch(editSupportProvider(data))
            .then(() => {
                handleEditModal();
                getList();
            })
            .catch(() => { });
    };
    return (
        <Modal
            open={openEditModal}
            destroyOnClose
            width={800}
            onCancel={handleEditModal}
            closeIcon={<FontAwesomeIcon icon={faTimes} />}
            footer={false}
            className="addModal"
            title={`Update Provider`}
        >
            <FormSupportProvider
                form={form}
                mode={'edit'}
                editModalData={editModalData}
                handleEditSubmit={handleEditSubmit}
                handleEditModal={handleEditModal}
            />
        </Modal>
    );
}
export default EditSupportProvider